(function () {
    'use strict';
    Controllers.NgReactRedirectWrapperController = class NgReactRedirectWrapperController extends Controllers.BaseControllerES6 {
        // @ngInject
        constructor($scope, $injector, StatsigService, integrationName) {
            super($scope, $injector);
            this.StatsigService = StatsigService;
            this.shouldRenderReact = undefined;
            this.integrationName = integrationName;

            const integrationGates = {
                'google': 'ng2react-google-integration',
                'calendly': 'ng2react-calendly-integration',
                'zoom': 'ng2react-zoom-integration'
            };

            // We want to have a specific gate for common integrations and one for all other integrations
            const gate = integrationGates[integrationName] || 'ng2react-other-integrations';

            this.StatsigService.isGateEnabled(gate, false)
                .then(isEnabled => {
                    this.shouldRenderReact = isEnabled;
                })
                .catch(() => {
                    this.shouldRenderReact = false;
                });
        }
    };
}());
